import axios from "axios";
import { SERVER_API } from "../../Constant";

export const FetchSalesPersons_api = async (
  page: number,
  limit: number,
  keyword: string,
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/SalesPerson/fetch_sales_persons.php`,
      {
        params: {
          page: page,
          limit: limit,
          keyword: keyword,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Fetch sales persons failed:", error);
    return { error: "Fetch sales persons failed" };
  }
};

export const AddSalesPerson_api = async (data: any) => {
  try {
    const response = await axios.post(
      `${SERVER_API}/SalesPerson/add_sales_person.php`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Add sales person failed:", error);
    return { error: "Add sales person failed" };
  }
};

export const UpdateSalesPerson_api = async (data: any) => {
  try {
    const response = await axios.post(
      `${SERVER_API}/SalesPerson/update_sales_person.php`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Update sales person failed:", error);
    return { error: "Update sales person failed" };
  }
};

export const DeleteSalesPerson_api = async (id: number) => {
  try {
    const response = await axios.post(
      `${SERVER_API}/SalesPerson/delete_sales_person.php`,
      { id },
    );
    return response.data;
  } catch (error) {
    console.error("Delete sales person failed:", error);
    return { error: "Delete sales person failed" };
  }
};
